import { render, staticRenderFns } from "./MpBackgroundWaves.vue?vue&type=template&id=01035293&scoped=true&"
import script from "./MpBackgroundWaves.vue?vue&type=script&lang=js&"
export * from "./MpBackgroundWaves.vue?vue&type=script&lang=js&"
import style0 from "./MpBackgroundWaves.vue?vue&type=style&index=0&id=01035293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01035293",
  null
  
)

export default component.exports